module.exports = __webpack_public_path__ + "media/start-quiz.c503e67c.mp3";